import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Table,
} from 'reactstrap';
import Panel from '../../../../../shared/components/Panel';
import { Theme } from '../../../../../shared/prop-types/MainProps';
import {
  getTableHeaderStyle,
  getTableRowStyle,
  getTableWrapperStyle,
  isDarkTheme,
} from '../../../../../shared/helpers/themeTableStyles';

function MainSettingsPanel({
  initialLoad, getData, mapLine, onUpdate, apiData, theme,
}) {
  const isDarkMode = isDarkTheme(theme);

  return (
    <Panel lg={12} title="Main Account Settings" getData={getData} parentRefresh={initialLoad}>
      <div style={getTableWrapperStyle(isDarkMode)}>
        <Table responsive className="table--bordered">
          <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
            <tr>
              <th style={getTableHeaderStyle(isDarkMode)}>Key</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Value</th>
            </tr>
          </thead>
          <tbody>
            {apiData && apiData.map((line, index) => mapLine(line, isDarkMode, index))}
            <tr style={getTableRowStyle(isDarkMode, apiData.length % 2 === 1)}>
              <td style={getTableRowStyle(isDarkMode, apiData.length % 2 === 1)}>
                <button type="button" className="badge badge-success badge-btn" onClick={() => onUpdate()}>Update Main Account Settings</button>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Panel>
  );
}

MainSettingsPanel.propTypes = {
  initialLoad: PropTypes.bool.isRequired,
  getData: PropTypes.func.isRequired,
  mapLine: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  apiData: PropTypes.instanceOf(Array).isRequired,
  theme: Theme.isRequired,
};

const mapStateToProps = (state) => {
  const { theme } = state;
  return { theme };
};

export default connect(mapStateToProps)(MainSettingsPanel);
